import { GenericRemoteActionBuilder } from '../remote-action-builder';
import { ViewContainerRef, ComponentRef } from '@angular/core';
import { LoggingService } from 'src/app/_services/logging/logic/logging.service';
import { ClientStateService } from 'src/app/_services/client-state/logic/client-state.service';
import { RemoteAction } from '../../remote-action';
import { TimeCorrectionRemoteActionBuilderUiStep } from '../../remote-action-builder-steps/time-correction-remote-action-builder-ui-step/time-correction-remote-action-builder-ui-step';
import { TimeCorrectionComponent } from 'src/app/_components/remote-action-step/time-correction/time-correction.component';
import { LocationService } from 'src/app/_services/location/location.service';
import { EmployeeService } from 'src/app/_services/employee/logic/employee.service';
import { AppService } from 'src/app/_services/app-service/logic/app.service';
import { CredentialsService } from 'src/app/_services/credentials/logic/credentials.service';
import { GpsRemoteActionBuilderServiceStep } from '../../remote-action-builder-steps/gps-remote-action-builder-service-step/gps-remote-action-builder-service-step';
import { AppParameterService } from 'src/app/_services/app-parameter/logic/app-parameter.service';
import { LBSUtils } from 'src/app/_util/lbs-utils';
import { CarSelectRemoteActionBuilderUiStep } from '../../remote-action-builder-steps/car-select-remote-action-builder-ui-step/car-select-remote-action-builder-ui-step';
import { CarSelectRaStepComponent } from 'src/app/_components/remote-action-step/car-select-ra-step/car-select-ra-step.component';
import { DriverSelectRemoteActionBuilderUiStep } from '../../remote-action-builder-steps/driver-select-remote-action-builder-ui-step/driver-select-remote-action-builder-ui-step';
import { TeamRemoteActionBuilderServiceStep } from '../../remote-action-builder-steps/team-remote-action-builder-service-step/team-remote-action-builder-service-step';
import { ServicejobSelectRemoteActionBuilderUIStep } from '../../remote-action-builder-steps/servicejob-select-remote-action-builder-ui-step/servicejob-select-remote-action-builder-ui-step';
import { ServicejobSelectRaStepComponent } from 'src/app/_components/remote-action-step/servicejob-select-ra-step/servicejob-select-ra-step.component';
import { CarsService } from 'src/app/_services/cars/logic/cars.service';
import { MilageRemoteActionBuilderUiStep } from '../../remote-action-builder-steps/mileage-remote-action-builder-ui-step/mileage-remote-action-builder-ui-step';
import { Car } from 'src/app/_model/car';

export class MileageRemoteActionBuilder extends GenericRemoteActionBuilder {
  constructor(
    private clientStateService: ClientStateService,
    appService: AppService,
    credentialsService: CredentialsService,
    private carsService: CarsService,
    locationService: LocationService,
    private appParameterService: AppParameterService,
    private car?: Car,
    private logger?: LoggingService
  ) {
    super(
      'MILEAGE-REMOTEACTION.PAGE-TITLE',
      appService,
      credentialsService,
      {
        endpoint: 'mileage',
        data: {
          curcarid: car?.getImsId(),
          carlabel: car?.displayLabel,
        },
        cachable: true,
        fifo: true,
        authenticationRequired: true,
        shortLabel: 'MILEAGE-REMOTEACTION.RA.LABEL.SHORT',
        shortLabelTranslate: true,
      },
      []
        .concat(
          [new CarSelectRemoteActionBuilderUiStep(logger)]
        )
        .concat([new MilageRemoteActionBuilderUiStep(logger)])
        .concat([new TimeCorrectionRemoteActionBuilderUiStep(logger)]),
      [new GpsRemoteActionBuilderServiceStep(locationService, logger)],
      async (data: any) => {
        logger.log(
          this.constructor.name,
          ' Executing post generate function',
          data
        );
      },
      logger
    );
  }

  public async next(dataValues?: { key: string; value: any }[]): Promise<any> {
    return super.next(dataValues);
  }

  public async generateRemoteAction(
    dataValues: { key: string; value: any }[]
  ): Promise<RemoteAction> {
    const ra: RemoteAction = await super.generateRemoteAction(dataValues);
    let carLabel = '';
    let mileage = '';
    if (ra.data['curcarid']) {
      carLabel =
        this.carsService.getCarById({
          imsId: ra.data['curcarid'],
          secondaryId: undefined,
          objRef: 'ims/Car',
        })?.displayLabel ?? '';
    }
    if (ra.data['mileage']) {
      mileage = `${ra.data['mileage']} km`;
    }
    return ra;
  }

  public generateComponent(
    viewContainerRef: ViewContainerRef
  ): ComponentRef<any> {
    const componentRef = super.generateComponent(viewContainerRef);

    // Configure specific Components
    if (componentRef.instance instanceof TimeCorrectionComponent) {
      (<TimeCorrectionComponent>componentRef.instance).setDescription(
        'MILEAGE-REMOTEACTION.DESCRIPTION'
      );
      (<TimeCorrectionComponent>componentRef.instance).setTitle(
        'MILEAGE-REMOTEACTION.TITLE'
      );
    }

    // Configure specific Components
    if (componentRef.instance instanceof CarSelectRaStepComponent) {
      const appParams = this.appParameterService.appParameters$.getValue();

      (<CarSelectRaStepComponent>componentRef.instance).useScanner(
        appParams.getBooleanParameter(
          'imsmc.remoteaction-step.car-select.scanmode',
          false
        )
      );

      if (
        LBSUtils.convertStringBool(
          appParams['imsmc.mileage.preselectedcar'],
          true
        )
      ) {
        (<CarSelectRaStepComponent>componentRef.instance).allowPreselection();
      }

      if (this.car != null) {
        (<CarSelectRaStepComponent>componentRef.instance).predeterminedCar = this.car;
      }
    }

    return componentRef;
  }
}
